define(function(require){
    'use strict';

    var _ = require('underscore');
    var Marionette          = require('marionette');
    var BaseModal           = require('modals/_base/view');
    var FooterTPL           = require('text!modals/email_edit/footer.tpl').default;
    var Config              = require('config/application');
    var Backbone            = require('backbone');
    var DomainsCollection 	= require('collections/mail_domains');
    var IntegratedEmails    = require('collections/integratedEmails');
    var TemplatesCollection = require('collections/messageTemplates');
    var TemplatesModel 	    = require('models/messageTemplate');
    var BodyView_v1         = require('modals/email_edit/BodyView_v1');
    var BodyView_v2         = require('modals/email_edit/BodyView_v2');

    var State = Backbone.Model.extend({
        defaults: {
            html: false,
        }
    });

    var FooterView  = Marionette.ItemView.extend({
        template    : FooterTPL,
        className   : 'b-popover__email_edit-footer',

        initialize : function (options){
            this.state = options.state;
        },

        onRender: function(){
            app.Rivets.bind(this.el, {state: this.state});
        },

        serializeData: function() {
            return {
                newTelephony: app.Models.Account.get('telephony_version') == 2
            }
        }
    });


    return BaseModal.extend({
        initialize: function(options) {
            BaseModal.prototype.initialize.call(this, options);
            this.state = new State();
            this.emails = new IntegratedEmails();
            this.domains = new DomainsCollection();
            this.templates = new TemplatesCollection();

            this.getAddresses()
              .then(function () {
                return this.templates.fetch({ data: { siteId: app.curProject.id, type: 1 } })
              }.bind(this))
              .then(function (response) {
                this.showBody();
              }.bind(this));

              this.listenTo(this.model.get('modalData').model, 'change:template_id', this.onChangeTemplateId)
        },

        onBeforeRender : function(){
            var self = this;
            var options = {
                width       : 900,
                show_header : false,
                show_footer : true
            };

            this.model.set(options);
        } ,

        showBody: function(){
          var BodyView = (app.Models.Account.get('telephony_version') != 2) ? BodyView_v1 : BodyView_v2;

          var body = new BodyView({
                model: this.model.get('modalData').model,
                domains: _.where(this.domains.toJSON(), {verified:true}),
                emails: _.where(this.emails.toJSON(), {type: 'smtp', valid: true}),
                templates: this.templates,
            });

            this.listenTo(body, 'toggleAddTemplateBtn', this.toggleAddTemplateBtn);
            this.listenTo(body, 'stateHasChanged', this.onStateHasChanged);

            this.modalBody.show(body);
        },

        showFooter: function(){
            this.modalFooter.show(new FooterView({state: this.state}));
            this.$('.js-add').click(this.emailEdited.bind(this));
            this.$('.js-save-template').click(this.saveTemplate.bind(this));
            this.$('.js-html').click(this.toggleHtml.bind(this));
        },

        emailEdited: function() {
            var templateId = this.model.get('modalData').model.get('template_id');
            var template = this.templates.get(templateId);

            if(this.model.get('modalData').model.isValid()) {
                if (template && template.isNew()) {
                    this.saveTemplate()
                        .then(function() {
                            this.closeModal();
                            this.trigger('email:edited', this.state.get('html'));
                        }.bind(this));
                } else {
                    this.closeModal();
                    this.trigger('email:edited', this.state.get('html'));
                }
            }
        },

        getAddresses: function() {
          return this.domains
            .fetch({ data: { site_id: app.curProject.id } })
            .then(function (response) {
              if (response.status == 1) {
                this.domains.reset(response.result);
              }
              if (app.Models.Account.get('telephony_version') != 2) {
                return true;
              } else {
                return this.emails.fetch();
              }
            }.bind(this));
        },

        saveTemplate: function() {

            $(".js-email-template-wrapper").removeClass('border-red');

            var def = new $.Deferred();
            var templateId = this.model.get('modalData').model.get('template_id');
            var template = this.templates.get(templateId);

            if (template && this.model.get('modalData').model.isValid()) {
                template.set({
                    template_subject: this.model.get('modalData').model.get('subject'),
                    template_text: this.model.get('modalData').model.get('text'),
                    is_html: this.state.get('html') ? 1 : 0
                });
                template
                    .save()
                    .then(function() {
                        app.message.success('Шаблон сохранен');
                        def.resolve();
                    }.bind(this))
                    .fail(function(xhr) {
                        var message = xhr.responseJSON && xhr.responseJSON.message || 'Не удалось сохранить шаблон';
                        app.message.error(message);
                    })
            }else{
                $(".js-email-template-wrapper").addClass('border-red');
                app.message.error('Введите название шаблона');
            }

            return def;
        },

        onChangeTemplateId: function(model, value) {
            var template = value && this.templates.get(value);

            if (template) {
                if (template.isNew()) {
                    this.$('.js-add').text('Отправить и сохранить шаблон');
                } else {
                    this.$('.js-add').text('Отправить');
                }
            }
            //this.$('.js-html').show();
        },

        //onStateHasChanged: function(state){
        //    this.state.set('html', state);
        //    console.log('State.html = ', state);
        //},

        onStateHasChanged: function (state) {
          this.state.set('html', state);
          console.log('State.html = ', state);
        },

        //toggleHtml: function () {
        //    app.confirm_modal({
        //        title_text: 'Вывод средств',
        //        body_text: 'Новое письмо в режиме HTML редактирования.',
        //        confirm_text: 'Вы уверены что хотите создать новое письмо в режиме HTML, текущее письмо будет потеряно?',
        //        show_input: false,
        //        textConfirm: false,
        //
        //        success: function () {
        //            //this.$('.js-html').hide();
        //            this.state.set('html', true);
        //
        //            this.$('textarea').val('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n<html xmlns="http://www.w3.org/1999/xhtml">\n<head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n<title></title>\n<meta name="viewport" content="width=device-width, initial-scale=1.0"/>\n</head>\n<body>\n</body>\n</html>');
        //            this.$('textarea').trigger('input');
        //        }.bind(this)
        //    })
        //},


        toggleAddTemplateBtn: function(value) {
            // this.$('.js-save-template').toggleClass('hidden', !value);
        },

        toggleHtml: function() {
            app.confirm_modal({
                title_text: 'Вывод средств',
                body_text: 'Новое письмо в режиме HTML редактирования.',
                confirm_text: 'Вы уверены что хотите создать новое письмо в режиме HTML, текущее письмо будет потеряно?',
                show_input: false,
                textConfirm: false,

                success: function () {
                    //this.$('.js-html').hide();
                    this.state.set('html', true);

                    this.$('textarea').val('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n<html xmlns="http://www.w3.org/1999/xhtml">\n<head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />\n<title></title>\n<meta name="viewport" content="width=device-width, initial-scale=1.0"/>\n</head>\n<body>\n</body>\n</html>');
                    this.$('textarea').trigger('input');
                }.bind(this)
            })
        },

        closeModal : function(){
            $.arcticmodal('close');
        }
    });

 });
